import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamDialog, AccVentureDialog } from '../../../../../../../ui/widget';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { DeliveryAccVenture } from '../all-ventures-view.part';

export function getActions(dialog: DialogService, areaService: DeliveryAreaService): GridAction<DeliveryAccVenture>[] {

	const actions: GridAction<DeliveryAccVenture>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Venture Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showCustom(AccVentureDialog, { data: { accVentureId: rows[0]!.accVentureId } }, 900, 700);
				await areaService.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Team Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showCustom(AccTeamDialog, { data: { accTeamId: rows[0]!.accTeamId } }, 900, 900);
				await areaService.reloadData();
			}
		}
	];

	return actions;
}